import React from 'react';
import Highcharts from 'highcharts/highstock';

import { CustomProvider, renderComponent } from "react/utils/renderUtils";
import StockTable from "react/components/StockTable";

Greenmile.RouteSummary = Greenmile.RouteSummary || {};

Greenmile.RouteSummary.SideBar = {

    routeData: {},

    showNoDataPlaceholder: function (messageText) {
        var placeholderTemplate = new Monet.UI.LayoutGenerator({
            items: [
                {
                    attributes: {
                        "class": "sidebarBackButton"
                    }
                },
                {
                    attributes: {
                        "id": "dataPlaceholder"
                    }
                },
                {
                    attributes: {
                        "id": "dataPlaceholderText"
                    },
                    html: messageText
                }
            ]
        }).render();

        var sideBar = this.getSideBar();
        sideBar.innerHTML = '';
        sideBar.appendChild(placeholderTemplate);
        this.addBackButtonListener();
    },

    showRouteStatistics: function () {

        Greenmile.RouteSummary.SideBar.filterButtonAction = (function (scope) {

            return function () {

                scope.getRoutesStatistics();

            };

        })(this);

        this.getRoutesStatistics();

    },

    getRoutesStatistics: function () {

        if (Greenmile.RouteSummary.SideBar.currentEntity === 'RouteView') {
            const criteriaChain = App.Forms.RouteSummaryRoutes.filterBuilder.getCriteriaChain();
            Greenmile.RouteSummary.Request.getRoutesStatistics(criteriaChain, (function (scope) {
                return function (data) {
                    if (data) {
                        scope.createRoutesStatisticsSideBar(data);
                    }
                };
            })(this));
        } else {
            this.getSideBar().innerHTML = '';
        }
    },

    getRouteInformation: function (route) {
        Greenmile.RouteSummary.Request.getRouteInformation(route, (function (scope) {
            return function (data) {
                if (data && data.length > 0) {
                    scope.routeData = route;
                    scope.createRouteSideBar(data[0]);
                } else {
                    scope.showNoDataPlaceholder(Monet.I18n.getResourcesByKey('RouteMonitor.sidebar.placeholder.nodata'));
                }
            };
        }(this)));
    },

    createRoutesStatisticsSideBar: function (data) {

        var totalNumberOfRoutes = this.getTotalNumberOfRoutesFromStatistics(data.byRouteStatus);
        var totalNumberOfGPSStatus = this.getTotalNumberOfGPSStatusFromStatistics(data.byGpsStatus);
        var totalNumberOfStops = this.getTotalNumberOfStopsFromStatistics(data.byStopStatus);

        var sideBar = this.getSideBar();

        var html = '<div class="routesStaticsContent">';
        if (totalNumberOfRoutes > 0) {
            html += '<div class="routesStatisticsSideBarHeader">' +
                Monet.I18n.getResourcesByKey('RouteMonitor.sidebar.placeholder.routesStatistics') +
                '</div>';
            html += '<div id="routesStatisticsChart" class="routesStaticsChart"></div>';

            html += '<div class="routesStatisticsSideBarHeader">';
            html += '<div class="routesStatisticsSideBarHeaderLabel">' +
                Monet.I18n.getResourcesByKey('RouteMonitor.sidebar.placeholder.numberOfRoutes') +
                '</div>';
            html += '<div class="routesStatisticsSideBarHeaderValue">' + totalNumberOfRoutes + '</div>';
            html += '</div>';
        }

        if (totalNumberOfGPSStatus > 0) {
            html += '<div class="routesStatisticsSideBarHeader">' +
                Monet.I18n.getResourcesByKey('RouteMonitor.sidebar.placeholder.routesGPSStatus') +
                '</div>';
            html += '<div id="routesGPSStatusChart" class="routesStaticsChart"></div>';
        }

        if (totalNumberOfStops > 0) {
            html += '<div class="routesStatisticsSideBarHeader">' +
                Monet.I18n.getResourcesByKey('RouteMonitor.sidebar.placeholder.routesStopsStatus') +
                '</div>';
            html += '<div id="routesStopsStatusChart" class="routesStaticsChart"></div>';

            html += '<div class="routesStatisticsSideBarHeader">';
            html += '<div class="routesStatisticsSideBarHeaderLabel">' +
                Monet.I18n.getResourcesByKey('RouteMonitor.sidebar.placeholder.numberOfStops') +
                '</div>';
            html += '<div class="routesStatisticsSideBarHeaderValue">' + totalNumberOfStops + '</div>';
            html += '</div>';
        }

        if (data.byCancelCode.length > 0) {
            html += '<div class="routesStatisticsSideBarHeader">' +
                Monet.I18n.getResourcesByKey('RouteMonitor.sidebar.placeholder.routesCancelCodeStatus') +
                '</div>';
            html += '<div id="routesCancelCodeStatusChart" class="routesStaticsChart"></div>';
        }

        if (data.byUndeliverableCode.length > 0) {
            html += '<div class="routesStatisticsSideBarHeader">' +
                Monet.I18n.getResourcesByKey('RouteMonitor.sidebar.placeholder.routesUndeliverableCodeStatus') +
                '</div>';
            html += '<div id="routesUndeliverableCodeStatusChart" class="routesStaticsChart"></div>';
        }

        if (data.byRedeliveryReason.length > 0) {
            html += '<div class="routesStatisticsSideBarHeader">' +
                Monet.I18n.getResourcesByKey('RouteMonitor.sidebar.placeholder.routesRedeliveryReasonStatus') +
                '</div>';
            html += '<div id="routesRedeliveryReasonStatusChart" class="routesStaticsChart"></div>';
        }

        html += '</div>';

        if (html === '<div class="routesStaticsContent"></div>') {
            html = '<div id="dataPlaceholder"></div><div id="dataPlaceholderText">' + Monet.I18n.getResourcesByKey('RouteMonitor.sidebar.placeholder.nodatatoday') + '</div>';
        }

        sideBar.innerHTML = html;

        this.replaceRouteStatusDescription(data.byRouteStatus);
        this.replaceStopStatusDescription(data.byStopStatus);
        this.replaceGPSStatusDescription(data.byGpsStatus);

        this.appendRoutesStatisticsChart(sideBar, 'routesStatisticsChart', data.byRouteStatus);
        this.appendRoutesStatisticsChart(sideBar, 'routesGPSStatusChart', data.byGpsStatus);
        this.appendRoutesStatisticsChart(sideBar, 'routesStopsStatusChart', data.byStopStatus);
        this.appendRoutesStatisticsChart(sideBar, 'routesCancelCodeStatusChart', data.byCancelCode);
        this.appendRoutesStatisticsChart(sideBar, 'routesUndeliverableCodeStatusChart', data.byUndeliverableCode);
        this.appendRoutesStatisticsChart(sideBar, 'routesRedeliveryReasonStatusChart', data.byRedeliveryReason);
        this.addFilterButtonListener();

    },

    getTotalNumberOfRoutesFromStatistics: function (routesStatistics) {

        return this.getTotalNumberFromStatisticsArray(routesStatistics);

    },

    getTotalNumberOfStopsFromStatistics: function (stopStatistics) {

        return this.getTotalNumberFromStatisticsArray(stopStatistics);

    },

    getTotalNumberOfGPSStatusFromStatistics: function (stopStatistics) {

        return this.getTotalNumberFromStatisticsArray(stopStatistics);

    },

    getTotalNumberFromStatisticsArray: function (genericArray) {

        var count = 0;

        for (var i = 0; i < genericArray.length; i++) {

            count += genericArray[i].value;

        }

        return count;

    },

    replaceRouteStatusDescription: function (routes) {

        var routeStatus = {

            "NOT_STARTED": Monet.I18n.getResourcesByKey('RouteMonitor.sidebar.routeStatistics.notStarted'),
            "STARTED": Monet.I18n.getResourcesByKey('RouteMonitor.sidebar.routeStatistics.started'),
            "DEPARTED_ORIGIN": Monet.I18n.getResourcesByKey('RouteMonitor.sidebar.routeStatistics.departedOrigin'),
            "ARRIVED_ORIGIN": Monet.I18n.getResourcesByKey('RouteMonitor.sidebar.routeStatistics.arrivedOrigin'),
            "COMPLETED": Monet.I18n.getResourcesByKey('RouteMonitor.sidebar.routeStatistics.completed')

        };

        for (var i = 0; i < routes.length; i++) {

            var statusDescription = routes[i].description;
            routes[i].description = routeStatus[statusDescription];

        }

    },

    replaceStopStatusDescription: function (stops) {

        var stopsStatus = {

            "DELIVERED": Monet.I18n.getResourcesByKey('RouteMonitor.sidebar.stopsStatistics.Delivered'),
            "CANCELLED": Monet.I18n.getResourcesByKey('RouteMonitor.sidebar.stopsStatistics.cancelled'),
            "UNDELIVERED": Monet.I18n.getResourcesByKey('RouteMonitor.sidebar.stopsStatistics.undelivered'),
            "PENDING": Monet.I18n.getResourcesByKey('RouteMonitor.sidebar.stopsStatistics.pending')

        };

        for (var i = 0; i < stops.length; i++) {

            var statusDescription = stops[i].description;
            stops[i].description = stopsStatus[statusDescription];

        }

    },

    replaceGPSStatusDescription: function (gps) {

        var gpsStatus = {

            "YES": Monet.I18n.getResourcesByKey('RouteMonitor.sidebar.gpsStatistics.yes'),
            "NO": Monet.I18n.getResourcesByKey('RouteMonitor.sidebar.gpsStatistics.no')

        };

        for (var i = 0; i < gps.length; i++) {

            var gpsDescription = gps[i].description;
            gps[i].description = gpsStatus[gpsDescription];

        }

    },

    appendRoutesStatisticsChart: function (sideBar, elementToAppend, data) {

        var chart = {
            data: {
                yAxis: "Route.Details",
                topResults: data
            },

            element: elementToAppend
        };

        var chartDiv = document.querySelector('#' + elementToAppend);

        if (chartDiv) {

            this.createPieChart(chart.data, chart.element, chart.title);

        }

        this.resizeSideList('.routesStaticsContent', 100);

    },

    createRouteSideBar: function (serverRoute) {
        this.createFloatMenu();
        this.createSizeDetails(serverRoute);
        this.getLineItemDetails(serverRoute);
    },

    createFloatMenu: function () {
        if (!Greenmile.RouteSummary.SideBar.FloatMenu) {
            var floatMenuTemplate = function () {
                var content = document.createElement('div');
                content.id = 'sidebarMenu';
                return content;
            };

            var taskList = new Monet.UI.List();
            taskList.itemRenderer = floatMenuTemplate;

            var taskMenu = new Monet.UI.FloatMenu(
                [
                    { id: 1, description: '', icon: '' }
                ],
                {
                    description: '',
                    targetEl: ''
                });

            taskMenu.listProvider = taskList;
            taskMenu.el.style.display = 'none';
            taskMenu.init();
            taskMenu.render();

            var y = document.querySelector('#RouteSummary');
            y.appendChild(taskMenu.el);
            Greenmile.RouteSummary.SideBar.FloatMenu = taskMenu;
        }
    },

    createSizeDetails: function (serverRoute) {

        if (!serverRoute.equipmentAssignments) {
            return;
        }

        var vehicleCapacitySize1 = this.getVehicleCapacitySize(serverRoute, serverRoute.equipmentAssignments[0].equipment.equipmentType.size1, 'plannedSize1'),
            vehicleCapacitySize2 = this.getVehicleCapacitySize(serverRoute, serverRoute.equipmentAssignments[0].equipment.equipmentType.size2, 'plannedSize2'),
            vehicleCapacitySize3 = this.getVehicleCapacitySize(serverRoute, serverRoute.equipmentAssignments[0].equipment.equipmentType.size3, 'plannedSize3'),
            sumActualSize1 = this.getStopSizeSum(serverRoute, 'actualSize1'),
            sumActualSize2 = this.getStopSizeSum(serverRoute, 'actualSize2'),
            sumActualSize3 = this.getStopSizeSum(serverRoute, 'actualSize3'),
            sumPlannedSize1 = this.getStopSizeSum(serverRoute, 'plannedSize1'),
            sumPlannedSize2 = this.getStopSizeSum(serverRoute, 'plannedSize2'),
            sumPlannedSize3 = this.getStopSizeSum(serverRoute, 'plannedSize3');

        var percentSize1 = ((sumPlannedSize1 - sumActualSize1) / vehicleCapacitySize1) * 100,
            percentSize2 = ((sumPlannedSize2 - sumActualSize2) / vehicleCapacitySize2) * 100,
            percentSize3 = ((sumPlannedSize3 - sumActualSize3) / vehicleCapacitySize3) * 100;

        var size1Graphic = Greenmile.Templates.routeCapacity({
            size: percentSize1
        });

        var size2Graphic = Greenmile.Templates.routeCapacity({
            size: percentSize2
        });

        var size3Graphic = Greenmile.Templates.routeCapacity({
            size: percentSize3
        });

        const remainingCapacity1 = (sumPlannedSize1 - sumActualSize1);
        const remainingCapacity2 = (sumPlannedSize2 - sumActualSize2);
        const remainingCapacity3 = (sumPlannedSize3 - sumActualSize3);

        Greenmile.RouteSummary.SideBar.remainingCapacity1 = (remainingCapacity1 < 0) ? 0 : remainingCapacity1;
        Greenmile.RouteSummary.SideBar.remainingCapacity2 = (remainingCapacity2 < 0) ? 0 : remainingCapacity2;
        Greenmile.RouteSummary.SideBar.remainingCapacity3 = (remainingCapacity3 < 0) ? 0 : remainingCapacity3;
        Greenmile.RouteSummary.SideBar.vehicleCapacitySize1 = vehicleCapacitySize1;
        Greenmile.RouteSummary.SideBar.vehicleCapacitySize2 = vehicleCapacitySize2;
        Greenmile.RouteSummary.SideBar.vehicleCapacitySize3 = vehicleCapacitySize3;

        Greenmile.RouteSummary.SideBar.size1Graphic = size1Graphic;
        Greenmile.RouteSummary.SideBar.size2Graphic = size2Graphic;
        Greenmile.RouteSummary.SideBar.size3Graphic = size3Graphic;
    },

    getLineItemDetails: function (serverRoute) {
        Greenmile.RouteSummary.Request.getLineItemInformation(serverRoute, (function (scope) {
            return function (data) {
                scope.createRouteDetails(serverRoute, data);
            };
        }(this)));
    },

    generateOldStockDetails: function (data, extras) {
        const subHeader = document.createElement('div');
        subHeader.setAttribute('class', 'subHeader');
        subHeader.setAttribute('style', 'margin-top: 36px');
        subHeader.textContent = Monet.I18n.getResourcesByKey('RouteMonitor.sidebar.route.skuDetails');

        const extraContent = document.createElement('div');
        extraContent.setAttribute('class', 'extraContent');

        const layout = function (data) {
            return {
                "items": [
                    {
                        "items": [
                            {
                                "beforeHtml": data.skuKey,
                                "attributes": {
                                    "class": "labelSKU",
                                    "title": data.skuKey
                                }
                            },
                            {
                                "beforeHtml": data.skuDescription,
                                "attributes": {
                                    "class": "labelDescription"
                                }
                            },
                            {
                                "items": [
                                    {
                                        "items": [
                                            {
                                                "items": [
                                                    {
                                                        "attributes": {
                                                            "class": "itemSize",
                                                            "style": "width:" + data.itemSize + "%"
                                                        }
                                                    },
                                                    {
                                                        "attributes": {
                                                            "class": "extraSize",
                                                            "style": "width:" + data.extraSize + "%"
                                                        }
                                                    },
                                                    {
                                                        "beforeHtml": data.totalItems + "/" + data.totalExtra +
                                                            "(" + parseInt(data.itemSize) + "%)",
                                                        "attributes": {
                                                            "class": "capacityDescription"
                                                        }
                                                    }
                                                ],
                                                "attributes": {
                                                    "class": "routeItemBar"
                                                }
                                            }
                                        ],
                                        "attributes": {
                                            "class": "menuContainerRouteLineItem"
                                        }
                                    }
                                ],
                                "attributes": {
                                    "class": "tableGraphic"
                                }
                            }
                        ],
                        "attributes": {
                            "class": "graphicLine",
                            "actualsize": data.actualSize,
                            "plannedsize": data.plannedSize,
                            "totalextra": data.totalExtra,
                            "totalundeliverable": data.totalUndeliverable
                        }
                    }
                ]
            };
        };

        for (let i = 0; i < data.length; i++) {
            const sumItemActualSize1 = (data[i].actualSize1 ? data[i].actualSize1 : 0);
            const sumItemPlannedSize1 = (data[i].plannedSize1 ? data[i].plannedSize1 : 0);
            const sumUndeliverableSize1 = (data[i].undeliverableSize1 ? data[i].undeliverableSize1 : 0);
            let sumExtraAvailableSize1 = 0, sumExtraPlannedSize1 = 0;

            for (let j = 0; j < extras.length; j++) {
                if (data[i].skuId === extras[j].sku.id) {
                    sumExtraAvailableSize1 += extras[j].availableSize1;
                    sumExtraPlannedSize1 += extras[j].plannedSize1;
                }
            }

            sumExtraAvailableSize1 += sumUndeliverableSize1;
            sumExtraPlannedSize1 += sumUndeliverableSize1;

            const totalItems = sumItemPlannedSize1 + sumExtraAvailableSize1;
            const difPlannedActual = sumItemPlannedSize1 - sumItemActualSize1;

            let percentDifference = (difPlannedActual / totalItems) * 100,
                percentExtraPlanned1 = (sumExtraPlannedSize1 / totalItems) * 100;

            percentDifference = (isNaN(percentDifference) === false ? percentDifference : 0);
            percentExtraPlanned1 = (isNaN(percentExtraPlanned1) === false ? percentExtraPlanned1 : 0);

            const item = {
                actualSize: sumItemActualSize1,
                plannedSize: sumItemPlannedSize1,
                totalItems,
                totalExtra: sumExtraAvailableSize1,
                totalUndeliverable: sumUndeliverableSize1,
                itemSize: percentDifference,
                extraSize: percentExtraPlanned1,
                skuDescription: data[i].skuDescription,
                skuKey: data[i].skuKey
            };

            extraContent.appendChild((new Monet.UI.LayoutGenerator(layout(item))).render());
        }

        return {
            extraContent,
            subHeader
        };
    },

    postGenerateOldStockDetails: function () {
        this.resizeLineItemList();
        this.addOnScrollEventListener();
    },

    createRouteDetails: function (serverRoute, data) {
        const sideBar = this.getSideBar();
        const layout = {
            "items": [
                {
                    "attributes": { "class": "sidebar-header" }, items: [
                        { "attributes": { "class": "sidebarBackButton" } },
                        {
                            "attributes": { "class": "sidebar-header-texts" }, items: [
                                {
                                    "beforeHtml": Monet.I18n.getResourcesByKey("RouteMonitor.sidebar.route.header") + " " + serverRoute.key,
                                    "attributes": { "class": "headerSidebar" }
                                },
                            ]
                        },
                    ]
                },
                {
                    "items": [
                        {
                            "beforeHtml": Monet.I18n.getResourcesByKey("RouteMonitor.sidebar.route.capacity"),
                            "attributes": { "class": "subHeader" }
                        }
                    ]
                },
                {
                    "items": [
                        {
                            "items": [
                                {
                                    "beforeHtml": Monet.Session.Configurations.size1Alias,
                                    "attributes": { "class": "labelGraphic" }
                                },
                                {
                                    "beforeHtml": Greenmile.RouteSummary.SideBar.size1Graphic,
                                    "attributes": { "class": "graphic" }
                                }
                            ],
                            "attributes": { "class": "line" }
                        },
                        {
                            "items": [
                                {
                                    "beforeHtml": Monet.Session.Configurations.size2Alias,
                                    "attributes": {
                                        "class": "labelGraphic"
                                    }
                                },
                                {
                                    "beforeHtml": Greenmile.RouteSummary.SideBar.size2Graphic,
                                    "attributes": {
                                        "class": "graphic"
                                    }
                                }
                            ],
                            "attributes": {
                                "class": "line"
                            }
                        },
                        {
                            "items": [
                                {
                                    "beforeHtml": Monet.Session.Configurations.size3Alias,
                                    "attributes": {
                                        "class": "labelGraphic"
                                    }
                                },
                                {
                                    "beforeHtml": Greenmile.RouteSummary.SideBar.size3Graphic,
                                    "attributes": {
                                        "class": "graphic"
                                    }
                                }
                            ],
                            "attributes": {
                                "class": "line"
                            }
                        }
                    ],
                    "attributes": {
                        "class": "vehicleCapacity"
                    }
                }
            ]
        };
        let extras = [],
            callback = function (data) {
                extras = data;
            };

        Greenmile.RouteSummary.Request.getRouteExtraInformation(serverRoute, callback);

        sideBar.innerHTML = '';
        sideBar.appendChild((new Monet.UI.LayoutGenerator(layout)).render());


        const { id } = serverRoute;

        if (data.length) {
            const featuresStates = GreenmileReduxStore.getState().features;

            if (featuresStates.has('STOCK_SUMMARY_DETAILS') && featuresStates.get('STOCK_SUMMARY_DETAILS').enabled) {
                const stockSummaryContainer = document.createElement('div');
                stockSummaryContainer.setAttribute('id', 'stock-summary');

                sideBar.appendChild(stockSummaryContainer);

                renderComponent(
                    <CustomProvider>
                        <StockTable routeId={id} />
                    </CustomProvider>,
                    stockSummaryContainer
                );
            } else {
                const { extraContent, subHeader } = this.generateOldStockDetails(data, extras);

                sideBar.appendChild(subHeader);
                sideBar.appendChild(extraContent);

                this.postGenerateOldStockDetails();
            }
        }

        this.addBackButtonListener();
        this.addOnMouseOverListener();
    },

    resizeLineItemList: function () {
        this.resizeSideList('.extraContent', 398);
    },

    addOnMouseOverListener: function () {

        $('#RouteSummary .st-menu').on("mouseenter", function () {
            var menu = document.querySelector('.MonetUIFloatMenu'),
                shouldAdd = true;

            if (menu) {
                var cn = 0,
                    max = menu.childNodes.length;

                for (cn = 0; cn < max; cn++) {
                    if (menu.childNodes[cn].className && menu.childNodes[cn].className === 'floatMenuContent') {
                        shouldAdd = false;
                    }
                }
            }

            if (shouldAdd) {
                var y = document.querySelector('#RouteSummary');

                Greenmile.RouteSummary.SideBar.FloatMenu.el.style.display = 'none';
                y.appendChild(Greenmile.RouteSummary.SideBar.FloatMenu.el);
            }
        });

        $('#RouteSummary .st-menu .vehicleCapacity').on('mousemove', function (e) {
            var taskMenu = Greenmile.RouteSummary.SideBar.FloatMenu;

            taskMenu.el.innerHTML = Greenmile.Templates.routeVehicleCapacity({
                remainingCapacity1: Greenmile.RouteSummary.SideBar.remainingCapacity1,
                remainingCapacity2: Greenmile.RouteSummary.SideBar.remainingCapacity2,
                remainingCapacity3: Greenmile.RouteSummary.SideBar.remainingCapacity3,
                capacity1: Greenmile.RouteSummary.SideBar.vehicleCapacitySize1,
                capacity2: Greenmile.RouteSummary.SideBar.vehicleCapacitySize2,
                capacity3: Greenmile.RouteSummary.SideBar.vehicleCapacitySize3
            });

            taskMenu.el.style.left = (e.pageX + 25) + 'px';
            taskMenu.el.style.top = (e.pageY - 90) + 'px';
            taskMenu.el.style.display = 'block';
        });

        $('#RouteSummary .st-menu .vehicleCapacity').on('mouseout', function () {
            var taskMenu = Greenmile.RouteSummary.SideBar.FloatMenu;
            taskMenu.el.style.display = 'none';
        });

        $('#RouteSummary .st-menu .graphicLine').on('mousemove', function (e) {
            const parent = $(e.target).closest('.graphicLine'),
                plannedSize = parent.attr('plannedSize'),
                actualSize = parent.attr('actualSize'),
                totalExtra = parent.attr('totalExtra');

            const taskMenu = Greenmile.RouteSummary.SideBar.FloatMenu;
            taskMenu.el.innerHTML = "";

            const floatMenuContent = document.createElement("div");
            floatMenuContent.setAttribute("class", "floatMenuContent");

            const getDescContainer = (resource, size) => {
                const description = document.createElement("div");
                description.setAttribute("class", "description");
                description.textContent = `${Monet.I18n.translateResourceSizes(resource)}: ${size}`;

                return description;
            };

            const descriptionTextOne = Monet.I18n.getResourcesByKey('LineItem.Grid.plannedSize1');
            const descriptionContainerOne = getDescContainer(descriptionTextOne, plannedSize);

            const descriptionTextTwo = Monet.I18n.getResourcesByKey('LineItem.Grid.actualSize1');
            const descriptionContainerTwo = getDescContainer(descriptionTextTwo, actualSize);

            const descriptionTextThree = Monet.I18n.getResourcesByKey('RouteMonitor.sidebar.route.extra');
            const descriptionContainerThree = getDescContainer(descriptionTextThree, totalExtra);

            floatMenuContent.appendChild(descriptionContainerOne);
            floatMenuContent.appendChild(descriptionContainerTwo);
            floatMenuContent.appendChild(descriptionContainerThree);

            taskMenu.el.appendChild(floatMenuContent);

            taskMenu.el.style.left = (e.pageX + 21) + 'px';
            taskMenu.el.style.top = (e.pageY - 70) + 'px';
            taskMenu.el.style.display = 'block';
        });

        $('#RouteSummary .st-menu .graphicLine').on('mouseout', function () {
            const taskMenu = Greenmile.RouteSummary.SideBar.FloatMenu;
            taskMenu.el.style.display = 'none';
        });
    },

    addOnScrollEventListener: function () {
        const extraContent = document.querySelector('.extraContent');

        if (extraContent) {
            extraContent.addEventListener("scroll", function () {
                const menu = document.querySelector('#RouteSummary .MonetUIFloatMenu');

                if (menu) {
                    let max = menu.childNodes.length,
                        canDelete = true;

                    for (let childNode = 0; childNode < max; childNode++) {
                        if (menu.childNodes[childNode].className && menu.childNodes[childNode].className === 'floatMenuContent') {
                            canDelete = false;
                        }
                    }

                    if (canDelete) {
                        const parent = menu.parentNode;
                        parent.removeChild(menu);
                    }
                }
            });
        }
    },

    addBackButtonListener: function () {
        const routeSummaryGrid = new Greenmile.RouteSummary.Grid();
        var backButton = document.querySelector('#RouteSummary .sidebarBackButton');
        var backButtonAction = (function (scope) {
            return function () {
                routeSummaryGrid.handlerActiveRowSelected(null, scope.grid);
                scope.getRoutesStatistics();

            };

        })(this);

        if (backButton) {
            backButton.removeEventListener('click', backButtonAction);
            backButton.addEventListener('click', backButtonAction);
        }
    },

    addFilterButtonListener: function () {

        var filterButton = document.querySelector('#RouteSummary .MonetUIFilterBuilderFilterButton');

        if (filterButton) {

            filterButton.removeEventListener('click', Greenmile.RouteSummary.SideBar.filterButtonAction);
            filterButton.addEventListener('click', Greenmile.RouteSummary.SideBar.filterButtonAction);

        }

    },

    getVehicleCapacitySize: function (route, size, stopSize) {
        var actualSize = this.getStopSizeSum(route, stopSize);

        if (typeof size === 'undefined') {
            return actualSize;
        } else {
            return Math.max(size, actualSize);
        }
    },

    getStopSizeSum: function (route, stopSize) {
        var sizeSum = 0;

        if (route.stops) {
            for (var i = 0; i < route.stops.length; i++) {
                if (route.stops[i][stopSize]) {
                    sizeSum += route.stops[i][stopSize];
                }
            }
        }
        return sizeSum;
    },

    getStopInformation: function (stop) {

        var _stop = (stop.model ? stop.model.get('stop') : stop);
        var location = _stop.location;

        if (!location) {
            this.showNoDataPlaceholder(Monet.I18n.getResourcesByKey('RouteMonitor.sidebar.placeholder.noLocationData'));
            return;
        }

        Greenmile.RouteSummary.Request.getDeliveryStatistics(location, (function (scope) {
            return function (data) {
                scope.createDeliveryStatisticsInformation(_stop, data);
            };
        }(this)));

        Greenmile.RouteSummary.Request.getLatestServices(location, (function (scope) {
            return function (data) {
                scope.createLatestServicesInformation(_stop, data);
            };
        }(this)));

        Greenmile.RouteSummary.Request.getChartInformation(location, 'TOP_CANCEL_CODE', (function (scope) {
            Greenmile.RouteSummary.SideBar.cancelChart = undefined;

            return function (data) {
                if (data && data.topResults.length !== 0) {
                    Greenmile.RouteSummary.SideBar.cancelChart = {
                        data: data,
                        element: 'cancelCode',
                        title: Monet.I18n.getResourcesByKey('Stop.Grid.cancelCode')
                    };

                    var chartDiv = document.querySelector('#cancelCode');

                    if (chartDiv) {
                        var cancelChart = Greenmile.RouteSummary.SideBar.cancelChart;
                        scope.createPieChart(cancelChart.data, cancelChart.element, cancelChart.title);
                    }
                }
            };
        }(this)));

        Greenmile.RouteSummary.Request.getChartInformation(location, 'TOP_UNDELIVERABLE_CODE', (function (scope) {
            Greenmile.RouteSummary.SideBar.undeliverableChart = undefined;

            return function (data) {
                if (data && data.topResults.length !== 0) {
                    Greenmile.RouteSummary.SideBar.undeliverableChart = {
                        data: data,
                        element: 'undeliverableCode',
                        title: Monet.I18n.getResourcesByKey('stop.undeliverableCode_key')
                    };

                    var chartDiv = document.querySelector('#undeliverableCode');

                    if (chartDiv) {
                        var undeliverableChart = Greenmile.RouteSummary.SideBar.undeliverableChart;
                        scope.createPieChart(undeliverableChart.data, undeliverableChart.element, undeliverableChart.title);
                    }
                }
            };
        }(this)));
    },

    routeMonitorSidebarStopDeliveryInfo: function (data) {
        return new Monet.UI.LayoutGenerator({
            "tag": "div",
            "items": [
                {
                    "beforeHtml": Monet.I18n.getResourcesByKey('RouteMonitor.sidebar.stopStatistics.statistics'),
                    "attributes": {
                        "class": "subHeader"
                    }
                },
                {
                    "items": [
                        {
                            "beforeHtml": Monet.I18n.getResourcesByKey('RouteMonitor.sidebar.stopStatistics.numDeliveries'),
                            "attributes": {
                                "class": "label"
                            }
                        },
                        {
                            "beforeHtml": data.numberOfDeliveriesValue,
                            "attributes": {
                                "class": "text"
                            }
                        }
                    ],
                    "attributes": {
                        "class": "line"
                    }
                },
                {
                    "items": [
                        {
                            "beforeHtml": Monet.I18n.getResourcesByKey('RouteMonitor.sidebar.stopStatistics.timeWindow'),
                            "attributes": {
                                "class": "label"
                            }
                        },
                        {
                            "beforeHtml": data.deliveriesOnTimeWindowValue,
                            "attributes": {
                                "class": "text"
                            }
                        }
                    ],
                    "attributes": {
                        "class": "line"
                    }
                },
                {
                    "items": [
                        {
                            "beforeHtml": data.avgSize1Label,
                            "attributes": {
                                "class": "label"
                            }
                        },
                        {
                            "beforeHtml": data.avgSize1Value,
                            "attributes": {
                                "class": "text"
                            }
                        }
                    ],
                    "attributes": {
                        "class": "line"
                    }
                },
                {
                    "items": [
                        {
                            "beforeHtml": data.avgSize2Label,
                            "attributes": {
                                "class": "label"
                            }
                        },
                        {
                            "beforeHtml": data.avgSize2Value,
                            "attributes": {
                                "class": "text"
                            }
                        }
                    ],
                    "attributes": {
                        "class": "line"
                    }
                },
                {
                    "items": [
                        {
                            "beforeHtml": data.avgSize3Label,
                            "attributes": {
                                "class": "label"
                            }
                        },
                        {
                            "beforeHtml": data.avgSize3Value,
                            "attributes": {
                                "class": "text"
                            }
                        }
                    ],
                    "attributes": {
                        "class": "line"
                    }
                }
            ]
        }).render().innerHTML;
    },

    createDeliveryStatisticsInformation: function (stop, data) {

        Greenmile.RouteSummary.SideBar.deliveryGraphic = this.routeMonitorSidebarStopDeliveryInfo({
            numberOfDeliveriesValue: data.numberOfDeliveries,
            deliveriesOnTimeWindowValue: data.deliveriesOnTimeWindow,
            avgSize1Label: Monet.I18n.translateResourceSizes(Monet.I18n.getResourcesByKey('RouteMonitor.sidebar.stopStatistics.Items.size1')),
            avgSize1Value: parseFloat(data.avgSize1).toFixed(2),
            avgSize2Label: Monet.I18n.translateResourceSizes(Monet.I18n.getResourcesByKey('RouteMonitor.sidebar.stopStatistics.Items.size2')),
            avgSize2Value: parseFloat(data.avgSize2).toFixed(2),
            avgSize3Label: Monet.I18n.translateResourceSizes(Monet.I18n.getResourcesByKey('RouteMonitor.sidebar.stopStatistics.Items.size3')),
            avgSize3Value: parseFloat(data.avgSize3).toFixed(2)
        });

        this.decorateStopSideBar();
    },

    createLatestServicesInformation: function (stop, data) {

        if (data) {

            var template = '<div class="subHeader">' +
                Monet.I18n.getResourcesByKey('RouteMonitor.sidebar.stopStatistics.history') +
                '</div>';
            data.forEach(function (item) {
                const date = Monet.Format.DateTime.formatToLocale(item.lastPlannedVisit);
                template += '<div class="line"> ' +
                    '<div class="stopLabel">' + item.driverName + '</div>' +
                    '<div class="stopText">' + date + '</div>' +
                    '</div>';
            });

            Greenmile.RouteSummary.SideBar.servicesGraphic = template;
        }

        this.decorateStopSideBar();
    },

    templateRouteMonitorSidebarStop: function (data) {
        return new Monet.UI.LayoutGenerator({
            items: [
                {
                    attributes: {
                        "class": "stop-details-container"
                    },
                    items: [
                        {
                            attributes: {
                                "class": "headerSidebar"
                            },
                            html: Monet.I18n.getResourcesByKey('RouteMonitor.sidebar.stop.header') + " "
                        },
                        {
                            attributes: {
                                "class": "stopExtraContent"
                            },
                            items: [
                                {
                                    beforeHtml: data.deliveryGraphic
                                },
                                {
                                    attributes: {
                                        "id": "cancelCode"
                                    }
                                },
                                {
                                    attributes: {
                                        "id": "undeliverableCode"
                                    }
                                },
                                {
                                    beforeHtml: data.serviceGraphic
                                }
                            ]
                        }
                    ]
                },
            ]
        }).render();
    },

    decorateStopSideBar: function () {
        var deliveryGraphic = Greenmile.RouteSummary.SideBar.deliveryGraphic,
            serviceGraphic = Greenmile.RouteSummary.SideBar.servicesGraphic,
            cancelChart = Greenmile.RouteSummary.SideBar.cancelChart,
            undeliverableChart = Greenmile.RouteSummary.SideBar.undeliverableChart;

        if (deliveryGraphic && serviceGraphic) {
            var stopTemplate = this.templateRouteMonitorSidebarStop({
                deliveryGraphic: deliveryGraphic,
                serviceGraphic: serviceGraphic
            }),
                sideBar = this.getSideBar();

            sideBar.innerHTML = '';
            sideBar.appendChild(stopTemplate);

            if (cancelChart) {
                this.createPieChart(cancelChart.data, cancelChart.element, cancelChart.title);
            }

            if (undeliverableChart) {
                this.createPieChart(undeliverableChart.data, undeliverableChart.element, undeliverableChart.title);
            }
        }

        this.resizeStopList();
    },

    createPieChart: function (data, element, title) {

        var values = [];

        if (data.topResults.length > 0) {

            for (var i = 0; i < data.topResults.length; i++) {
                values.push([
                    data.topResults[i].description,
                    data.topResults[i].value
                ]);
            }

        } else {
            return;
        }

        new Highcharts.Chart({
            chart: {
              type: 'pie',
              reflow: true,
              backgroundColor: 'transparent',
              height: 300 + 8 * data.topResults.length, //pie height plus legends height, avoiding squeezing and overlapping
              width: 250,
              spacingTop: 15,
              spacingBottom: 15,
              spacingLeft: 0,
              renderTo:  document.getElementById(element)
            },
            credits: {
                enabled: false
            },
            title: {
                text: title,
                style: {
                    color: '#1A2127'
                }
            },
            xAxis: {
                gridLineWidth: 1,
                lineColor: 'rgb(194, 194, 194)',
                tickColor: 'rgb(194, 194, 194)',
                labels: {
                    style: {
                        color: 'rgb(194, 194, 194)'
                    }
                },
                title: {
                    style: {
                        color: 'rgb(194, 194, 194)'
                    }
                }
            },
            yAxis: {
                minorTickInterval: 'auto',
                lineColor: 'rgb(194, 194, 194)',
                lineWidth: 1,
                tickWidth: 1,
                tickColor: 'rgb(194, 194, 194)',
                labels: {
                    style: {
                        color: 'rgb(194, 194, 194)'
                    }
                },
                title: {
                    style: {
                        color: 'rgb(194, 194, 194)'
                    }
                }
            },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: false,
                        color: 'rgb(194, 194, 194)',
                        connectorColor: 'rgb(194, 194, 194)',
                        formatter: function () {
                            return '<b>' + Monet.I18n.getResourcesByKey(this.point.name) + '</b>: ' + this.percentage.toFixed(2) + ' %';
                        }
                    },
                    showInLegend: true,
                    size: '185px'
                }
            },
            legend: {
                width: 250,
                borderWidth: 0,
                verticalAlign: 'bottom',
                labelFormatter: function () {
                    return '<div> <span style="color: #1A2127; font-weight: 500">' + this.name + ': </span> <span style="color: #1A2127; font-weight:normal;">' + this.y + ' / ' + this.percentage.toFixed(2) + '% </span> </div>';
                }
            },
            series: [{
                type: 'pie',
                data: values
            }],
            tooltip: {
                formatter: function () {
                    return '<b>' + this.y + '</b> : <b>' + this.total + '</b>';
                }
            },
            exporting: {
                enabled: false
            }
        });
    },

    resizeStopList: function () {
        this.resizeSideList('.stopExtraContent', 188);
    },

    resizeSideList: function (selector, padding) {
        var extraDiv = document.querySelector(selector);

        if (extraDiv) {
            extraDiv.style.height = window.innerHeight - padding + 'px';
        }

        window.addEventListener('resize', function () {
            var extraDiv = document.querySelector(selector);

            if (extraDiv) {
                extraDiv.style.height = window.innerHeight - padding + 'px';
            }
        }, true);
    },

    getSideBar: function () {
        return document.querySelector('#RouteSummary #menu-left');
    },

    clearStockSummaryInterval: function () {
        const timeinterval = App.Forms.RouteSummaryStock?.interval;

        if (timeinterval) {
            clearInterval(timeinterval);
        }
    },

    createPopOverHTML: function (data) {
        const { planned, actual, damaged, extra, missing, pickup } = data;

        let html = '';
        html += '<table class="stockSummaryTable" cellspacing="0" cellpading="0">';

        html += '<tr>';
        html += `<td>${Monet.I18n.getResourcesByKey('intactStock.planned')}</td>`;
        html += `<td>${planned?.$display || ''}</td>`;
        html += '</tr>';

        html += '<tr>';
        html += `<td>${Monet.I18n.getResourcesByKey('intactStock.delivered')}</td>`;
        html += `<td>${actual?.$display || ''}</td>`;
        html += '</tr>';

        html += '<tr>';
        html += `<td>${Monet.I18n.getResourcesByKey('damagedStock.damaged')}</td>`;
        html += `<td>${damaged?.$display || ''}</td>`;
        html += '</tr>';

        html += '<tr>';
        html += `<td>${Monet.I18n.getResourcesByKey('intactStock.collected')}</td>`;
        html += `<td>${pickup?.$display || ''}</td>`;
        html += '</tr>';

        html += '<tr>';
        html += `<td>${Monet.I18n.getResourcesByKey('intactStock.extra')}</td>`;
        html += `<td>${extra?.$display || ''}</td>`;
        html += '</tr>';

        html += '<tr>';
        html += `<td>${Monet.I18n.getResourcesByKey('intactStock.missing')}</td>`;
        html += `<td>${missing?.$display || ''}</td>`;
        html += '</tr>';

        html += "</table>";


        return html;
    },

    stockSummaryShowInfo: function (event, row) {
        const routeSummaryElement = document.querySelector('#RouteSummary');

        if (!App.Forms.RouteSummaryStock.FloatMenu || !routeSummaryElement.querySelector(".MenuStockSummary")) {

            const contentStop = document.createElement('div');
            contentStop.innerHTML = this.createPopOverHTML(row);

            const taskList = new Monet.UI.List();
            taskList.itemRenderer = () => contentStop;

            const stopMenu = new Monet.UI.FloatMenu([
                { id: 4, description: '', icon: '' }
            ], {
                description: '',
                targetEl: ''
            });

            stopMenu.listProvider = taskList;
            stopMenu.init();
            stopMenu.render(event.clientX, event.pageY);

            App.Forms.RouteSummaryStock.FloatMenu = stopMenu;
            App.Forms.RouteSummaryStock.FloatMenu.el.className = 'MonetUIFloatMenu MenuDown MenuStockSummary';

            routeSummaryElement.appendChild(App.Forms.RouteSummaryStock.FloatMenu.el);

        } else {
            App.Forms.RouteSummaryStock.FloatMenu.el.innerHTML = this.createPopOverHTML(row);
            App.Forms.RouteSummaryStock.FloatMenu.el.style.display = 'block';
        }

        const menuEl = App.Forms.RouteSummaryStock.FloatMenu.el;
        const menuHeight = menuEl.offsetHeight;

        const mouseY = event.clientY;

        if ((menuHeight + 70 + mouseY) > window.innerHeight) {
            menuEl.style.top = (mouseY - (menuHeight + 98)) + 'px';
            menuEl.className = 'MonetUIFloatMenu MenuTop MenuStockSummary';
        } else {
            menuEl.style.top = (mouseY - 50) + 'px';
            menuEl.className = 'MonetUIFloatMenu MenuDown MenuStockSummary';
        }

        menuEl.style.left = 140 + 'px';
    },

    stockSummaryMouseOutSlice: function () {
        App.Forms.RouteSummaryStock.FloatMenu.el.style.display = 'none';
    },
};
